import { css } from '@emotion/css';

import { Spacing } from 'apps/shared/scripts/styles/constants';

export const bodyClassName = css({
  flexGrow: 1,
  overflow: 'auto',
  paddingBottom: Spacing.LG,
  zIndex: 0,
});
